var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuccess32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,-4.68749874e-08 C6.71572873,-4.68749874e-08 -4.68750017e-08,6.71572873 -4.68750017e-08,15 C-4.68750017e-08,23.2842713 6.71572873,30 15,30 C23.2842713,30 30,23.2842713 30,15 C30,6.71572873 23.2842713,-4.68749874e-08 15,-4.68749874e-08 Z M23.49,11.59 L13.59,21.49 C13.2148635,21.8655541 12.7058185,22.0765733 12.175,22.0765733 C11.6441815,22.0765733 11.1351365,21.8655541 10.76,21.49 L9.33999998,20.07 L6.50999997,17.24 C6.00446916,16.7344692 5.80703691,15.997642 5.99207403,15.3070741 C6.17711114,14.6165061 6.7165061,14.0771112 7.40707403,13.8920741 C8.09764196,13.7070369 8.83446917,13.9044692 9.33999998,14.41 L12.17,17.24 L20.66,8.75999998 C21.4414829,7.97851708 22.7085171,7.97851709 23.49,8.76 C24.2714829,9.54148292 24.2714829,10.8085171 23.49,11.59 L23.49,11.59 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CBA-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconSuccess32",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons/32/iconStatusApprove32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, -1.000000)",
    id: "\\uD83C\\uDFA8-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Colour/brand/green",
    fill: "#5AE18C",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess32);
export default __webpack_public_path__ + "static/media/iconSuccess32.53dae51990baa0b5b95deafaad7172ce.svg";
export { ForwardRef as ReactComponent };